import React from "react";

/**
 * Actions Dropdown Component
 * Reusable component for duplicate/delete actions dropdown menu
 */
const ActionsDropdown = ({
  isOpen,
  itemId,
  onDuplicate,
  onDelete,
  duplicateLoading,
  deleteLoading,
  deleteId,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <ul className="dropdown-menu1" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        {duplicateLoading === false ? (
          <li 
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate();
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <span>
              {" "}
              <span>Duplicate</span>
            </span>
          </li>
        ) : (
          <li
            style={{
              pointerEvents: "none",
              cursor: "default",
              opacity: 0.7,
            }}
          >
            <div
              style={{
                width: "80px",
                height: "18px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </li>
        )}
        <li 
          onClick={
            itemId === deleteId && deleteLoading
              ? undefined
              : (e) => {
                  e.stopPropagation();
                  onDelete();
                }
          }
          onMouseDown={(e) => e.stopPropagation()}
          style={{
            pointerEvents: itemId === deleteId && deleteLoading ? "none" : "auto",
            cursor: itemId === deleteId && deleteLoading ? "default" : "pointer",
            opacity: itemId === deleteId && deleteLoading ? 0.7 : 1,
          }}
        >
          {itemId === deleteId && deleteLoading ? (
            <div
              style={{
                width: "60px",
                height: "18px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          ) : (
            <span>Delete</span>
          )}
        </li>
      </ul>
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

export default ActionsDropdown;
